// removed by extract-text-webpack-plugin
module.exports = {"Logo":"Logo__Logo__2xcEP","Color1":"Logo__Color1__3Et7D","Color2":"Logo__Color2__8qbPA"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Logo/Logo.css
// module id = 38
// module chunks = 0